import '../fesd/fesd'
import '../../sass/csr/csr.sass'
import { methods } from '../includes/_methods'
import { _dropdown } from '../includes/_dropdown.js'
import Swiper from 'swiper'

let rightSwiper;
let otherSwiper;

const _csr = {
  // 相關文章
  // 相關文章swiper
  // 判斷數量啟動swiper
  swiperAct() {
    let len = $('.swiper-left .swiper-slide').length;
    // 右側設定
    let rightSet = {
      on: {
        init() {
          if($(window).outerWidth() >= 1201) {
            methods.getSlidesCount(this);
          }
        }
      },
      loop: true,
      speed: 1000,
      initialSlide: 1,
      navigation: {
        nextEl: '.swiper-left .swiper-button-next',
        prevEl: '.swiper-left .swiper-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        1501: {
          slidesPerView: 2,
        }
      }
    }
    if(len > 2) {
      _csr.swiperLeft();
      _csr.swiperRight(rightSet);
      $('.swiper-left .swiper-container').addClass('swiper-no-swiping')
      $('.swiper-right .swiper-container').addClass('swiper-no-swiping')
      if($(window).outerWidth() <= 1200) {
        $('.swiper-left .swiper-container').removeClass('swiper-no-swiping');
        // rightSwiper.destroy();
      }
    }
    else if (len === 2) {
      rightSet.loop = false;
      _csr.swiperLeft();
      _csr.swiperRight(rightSet);
      $('.swiper-right .swiper-slide:nth-child(1)').hide();
    }
    else {
      $('.swiper-wrap').addClass('one');
      $('.swiper-right').hide();
    }
    
  },
  swiperLeft() {
    const setting = {
      on: {
        init() {
          methods.getSlidesCount(this);
        }
      },
      loop: true,
      speed: 1000,
      navigation: {
        nextEl: '.swiper-left .swiper-button-next',
        prevEl: '.swiper-left .swiper-button-prev',
      },
    }
    const leftSwiper = new Swiper('.swiper-left .swiper-container', setting)
  },
  swiperRight(setting) {
    rightSwiper = new Swiper('.swiper-right .swiper-container', setting)
  },

  // 傷口照護(首頁的搬過來改)
  // 斷點
  otherBkp(){
    let check = function(){
      if(window.innerWidth <= 1200) return true
    }
    // 手機版啟動 swiper
    if(check()) _csr.other();
    // 電腦版
    else {
      if(otherSwiper !== undefined) otherSwiper.destroy();
    }
  },
  // 預設第二則加樣式
  init() {
    let li = $('.csr-culture .swiper-slide a');
    li.each(function(i){
      // 預設第二則+效果
      if(i === 1){
        let bgSrc = $(this).parents('.swiper-slide').attr('data-bg');
        $(this).addClass('active');
        $('.csr-culture .content').css('background-image', `url(${bgSrc})`);
      }
    });
    li.on('mouseenter',function(){
      let bgSrc = $(this).parents('.swiper-slide').attr('data-bg');
      $(this).parents('.swiper-slide').siblings().find('a').removeClass('active');
      $(this).addClass('active');
      $('.csr-culture .content').css('background-image', `url(${bgSrc})`);
    });
  },
  // 傷口照護swiper
  otherEvent() {
    let active = $('.csr-culture .swiper-slide-active a');
    let bgPath = $('.csr-culture .content');
    let bgSrc = $('.csr-culture .swiper-slide-active').attr('data-bg');
    active.addClass('active');
    active.parents('.swiper-slide').siblings().find('a').removeClass('active');
    bgPath.css('background-image', `url(${bgSrc})`);
  },
  other() {
    const setting = {
      on: {
        init() {
          methods.getSlidesCount(this);
          _csr.otherEvent();
        },
        slideChangeTransitionStart() {
          _csr.otherEvent();
        }
      },
      speed: 1500,
      // loop: true,
      // autoplay: {
      //   delay: 3000,
      //   disableOnInteraction: false
      // },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: '.csr-culture .swiper-button-next',
        prevEl: '.csr-culture .swiper-button-prev',
      }
    }
    otherSwiper = new Swiper('.csr-culture .swiper-container', setting)
  },
  all() {
    _csr.init();
    _csr.swiperAct();
    _csr.otherBkp();
    methods.resize(_csr.otherBkp);
  }
}

$(function(){
  _csr.all();
  methods.lickSwitchClass('.row-dropdown.desktop li', 'active');
  _dropdown.all();
});